// const API_BASE_URL = process.env.NODE_ENV === 'production' 
//   ? 'http://localhost:5001/api' 
//   : process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001/api';
// const API_BASE_URL = 'http://localhost:5001/api';  
// const API_BASE_URL = 'https://restroai.in/api';
const API_BASE_URL = 'https://restro-backend-vercel.vercel.app/api';
export const API_ENDPOINTS = {
  // Authentication endpoints
  AUTH_LOGIN: `${API_BASE_URL}/auth/login`,
  AUTH_REGISTER: `${API_BASE_URL}/auth/register`,
  AUTH_REGISTER_CUSTOMER: `${API_BASE_URL}/auth/register-customer`,
  AUTH_VERIFY_TOKEN: `${API_BASE_URL}/auth/verify`,
  AUTH_CREATE_SUPERADMIN: `${API_BASE_URL}/auth/create-superadmin`,
  
  // Menu endpoints
  MENU: `${API_BASE_URL}/menu`,
  MENU_ADD: `${API_BASE_URL}/menu/add`,
  MENU_ITEM: (id) => `${API_BASE_URL}/menu/${id}`,
  MENU_TOGGLE_AVAILABILITY: (id) => `${API_BASE_URL}/menu/${id}/toggle-availability`,
  MENU_TOGGLE_QUICK_SERVE: (id) => `${API_BASE_URL}/menu/${id}/toggle-quickServe`,
  
  // Customer endpoints
  CUSTOMER_MENU: `${API_BASE_URL}/customer/menu`,
  CUSTOMER_ORDER_HISTORY: (restaurantId, mobileNumber, customerName) => {
    const params = new URLSearchParams();
    if (mobileNumber) params.append('mobileNumber', mobileNumber);
    if (customerName) params.append('customerName', customerName);
    return `${API_BASE_URL}/customer/orders/history/${restaurantId}?${params.toString()}`;
  },
  CUSTOMER_PROFILE: (phoneNumber) => `${API_BASE_URL}/customer/profile/${phoneNumber}`,
  CUSTOMER_PROFILE_UPDATE: (phoneNumber) => `${API_BASE_URL}/customer/profile/${phoneNumber}`,
  CUSTOMER_TABLE_DETAILS: (tableId) => `${API_BASE_URL}/customer/table/${tableId}`,
  CUSTOMER_ADD_FAVORITE: (phoneNumber) => `${API_BASE_URL}/customer/${phoneNumber}/favorites`,
  CUSTOMER_REMOVE_FAVORITE: (phoneNumber) => `${API_BASE_URL}/customer/${phoneNumber}/favorites`,
  CUSTOMER_INSIGHTS: (phoneNumber, restaurantId) => `${API_BASE_URL}/customer/insights/${phoneNumber}/${restaurantId}`,
  
  // Order endpoints
  ORDERS: `${API_BASE_URL}/orders`,
  ORDERS_ADD: `${API_BASE_URL}/orders/add`,
  ORDER_BY_ID: (orderId) => `${API_BASE_URL}/orders/${orderId}`,
  ORDER_SEND_BILL: (orderId, via) => `${API_BASE_URL}/orders/${orderId}/sendBill?via=${via}`,
  ORDER_SEND_BILL_EMAIL: (orderId, email) => `${API_BASE_URL}/orders/${orderId}/sendBill?via=email&email=${encodeURIComponent(email)}`,
  ORDER_PRINT_BILL: (orderId) => `${API_BASE_URL}/orders/${orderId}/printBill`,
  ORDERS_BY_TABLE: (tableId, startDate, endDate) => `${API_BASE_URL}/orders/table/${tableId}?startDate=${startDate}&endDate=${endDate}`,
  
  // Counter Order endpoints
  COUNTER_ORDERS: (restaurantId) => `${API_BASE_URL}/orders/counter/${restaurantId}`,
  COUNTER_ORDERS_ADD: `${API_BASE_URL}/orders/counter/add`,
  
  // Table endpoints
  TABLES: (restaurantId) => `${API_BASE_URL}/tables?restaurantId=${restaurantId}`,
  TABLES_ADD: `${API_BASE_URL}/tables/add`,
  TABLE_STATUS: (id) => `${API_BASE_URL}/tables/${id}/status`,
  TABLE_DELETE: (id) => `${API_BASE_URL}/tables/${id}`,
  TABLE_QR: (id, restaurantId) => `${API_BASE_URL}/tables/${id}/qr?restaurantId=${restaurantId}`,
  TABLE_OCCUPY: (id) => `${API_BASE_URL}/tables/${id}/occupy`,
  TABLE_FREE: (id) => `${API_BASE_URL}/tables/${id}/free`,
  
  // Restaurant endpoints
  RESTAURANTS_ALL: `${API_BASE_URL}/restaurants/all-restaurants`,
  RESTAURANTS_REGISTER: `${API_BASE_URL}/restaurants/register`,
  RESTAURANT_BY_ID: (id) => `${API_BASE_URL}/restaurants/getRestaurantsById/${id}`,
  RESTAURANT_UPDATE: (id) => `${API_BASE_URL}/restaurants/${id}`,
  RESTAURANT_TOGGLE_STATUS: (id) => `${API_BASE_URL}/restaurants/${id}/toggle-status`,
  RESTAURANT_DELETE: (id) => `${API_BASE_URL}/restaurants/${id}`,

  // Contact / Free Trial leads (public submit, super admin list)
  CONTACT_LEADS_SUBMIT: `${API_BASE_URL}/contact-leads`,
  CONTACT_LEADS_LIST: (filter) => `${API_BASE_URL}/contact-leads${filter ? `?filter=${filter}` : ''}`,
  CONTACT_LEAD_GET: (id) => `${API_BASE_URL}/contact-leads/${id}`,
  CONTACT_LEAD_UPDATE: (id) => `${API_BASE_URL}/contact-leads/${id}`,
  CONTACT_LEAD_DELETE: (id) => `${API_BASE_URL}/contact-leads/${id}`,
  CONTACT_LEAD_UPDATE_STATUS: (id) => `${API_BASE_URL}/contact-leads/${id}/status`,
  
  // Analytics endpoints
  ANALYTICS_REVENUE: (restaurantId) => `${API_BASE_URL}/analytics/revenue/${restaurantId}`,
  ANALYTICS_BEST_SELLING: (restaurantId) => `${API_BASE_URL}/analytics/bestselling/${restaurantId}`,
  ANALYTICS_CATEGORY: (restaurantId) => `${API_BASE_URL}/analytics/category/${restaurantId}`,
  ANALYTICS_VEG_NONVEG: (restaurantId) => `${API_BASE_URL}/analytics/veg-nonveg/${restaurantId}`,
  ANALYTICS_CUSTOMER_INSIGHTS: `${API_BASE_URL}/analytics/customer-insights`,
  ANALYTICS_ORDERS_BY_PERIOD: `${API_BASE_URL}/analytics/orders-by-period`,
  ANALYTICS_SALES_PERFORMANCE: (restaurantId, groupBy) => `${API_BASE_URL}/analytics/sales-performance/${restaurantId}?groupBy=${groupBy}`,
  ANALYTICS_ORDER_VOLUME: `${API_BASE_URL}/analytics/order-volume`,
  ANALYTICS_EXPORT: `${API_BASE_URL}/analytics/export`,
  ANALYTICS_SCHEDULE_EMAIL: `${API_BASE_URL}/analytics/schedule-email`,
  ANALYTICS_DAILY_AI_SUMMARY: (restaurantId) =>
    `${API_BASE_URL}/analytics/daily-ai-summary/${restaurantId}`,
  ANALYTICS_DAILY_AI_SUMMARY_REFRESH: (restaurantId) =>
    `${API_BASE_URL}/analytics/daily-ai-summary/${restaurantId}/refresh`,
  
  // Waiter Request endpoints
  WAITER_REQUESTS: `${API_BASE_URL}/waiter-requests`,
  WAITER_REQUESTS_BY_RESTAURANT: (restaurantId) => `${API_BASE_URL}/waiter-requests/restaurant/${restaurantId}`,
  WAITER_REQUEST_UPDATE: (id) => `${API_BASE_URL}/waiter-requests/${id}`,
  WAITER_REQUESTS_PENDING_COUNT: (restaurantId) => `${API_BASE_URL}/waiter-requests/restaurant/${restaurantId}/pending-count`,
  CUSTOMER_WAITER_REQUESTS: (customerMobile, restaurantId) => `${API_BASE_URL}/waiter-requests/customer/${customerMobile}/restaurant/${restaurantId}`,
  WAITER_REQUESTS_BY_WAITER: (waiterId, restaurantId) => `${API_BASE_URL}/waiter-requests/waiter/${waiterId}/restaurant/${restaurantId}`,
  WAITER_REQUESTS_PENDING_COUNT_BY_WAITER: (waiterId, restaurantId) => `${API_BASE_URL}/waiter-requests/waiter/${waiterId}/restaurant/${restaurantId}/pending-count`,
  
  // Special Offers endpoints
  OFFERS: `${API_BASE_URL}/offers`,
  
  // Inventory endpoints
  INVENTORY_INGREDIENTS: `${API_BASE_URL}/inventory/ingredients`,
  INVENTORY_INGREDIENT: (id) => `${API_BASE_URL}/inventory/ingredients/${id}`,
  INVENTORY_RECIPES: `${API_BASE_URL}/inventory/recipes`,
  INVENTORY_RECIPE: (id) => `${API_BASE_URL}/inventory/recipes/${id}`,
  INVENTORY_RECIPE_BY_MENU_ITEM: (menuItemId) => `${API_BASE_URL}/inventory/recipes/menu-item/${menuItemId}`,
  INVENTORY_TRANSACTIONS: `${API_BASE_URL}/inventory/transactions`,
  INVENTORY_STOCK_REPORT: `${API_BASE_URL}/inventory/reports/stock`,
  INVENTORY_COST_ANALYSIS: `${API_BASE_URL}/inventory/reports/cost-analysis`,
  
  // Staff endpoints
  STAFF_ALL: (restaurantId) => `${API_BASE_URL}/staff/restaurant/${restaurantId}`,
  STAFF_BY_ID: (id) => `${API_BASE_URL}/staff/${id}`,
  STAFF_CREATE: `${API_BASE_URL}/staff`,
  STAFF_UPDATE: (id) => `${API_BASE_URL}/staff/${id}`,
  STAFF_DELETE: (id) => `${API_BASE_URL}/staff/${id}`,
  STAFF_ACTIVATE: (id) => `${API_BASE_URL}/staff/${id}/activate`,
  STAFF_PERMANENT_DELETE: (id) => `${API_BASE_URL}/staff/${id}/permanent`,
  STAFF_RESET_PASSWORD: (id) => `${API_BASE_URL}/staff/${id}/reset-password`,
  STAFF_PERFORMANCE: (restaurantId) => `${API_BASE_URL}/staff/performance/${restaurantId}`,
  
  // Role endpoints
  ROLES_ALL: (restaurantId) => `${API_BASE_URL}/roles/restaurant/${restaurantId}`,
  ROLE_BY_ID: (id) => `${API_BASE_URL}/roles/${id}`,
  ROLE_CREATE: `${API_BASE_URL}/roles`,
  ROLE_UPDATE: (id) => `${API_BASE_URL}/roles/${id}`,
  ROLE_DELETE: (id) => `${API_BASE_URL}/roles/${id}`,
  
  // Attendance endpoints
  ATTENDANCE_CHECKIN: `${API_BASE_URL}/attendance/checkin`,
  ATTENDANCE_CHECKOUT: `${API_BASE_URL}/attendance/checkout`,
  ATTENDANCE_GET: `${API_BASE_URL}/attendance`,
  ATTENDANCE_CURRENT: (restaurantId) => `${API_BASE_URL}/attendance/current/${restaurantId}`,
  
  // Feedback endpoints
  FEEDBACK_CREATE: `${API_BASE_URL}/feedback`,
  FEEDBACK_GET: `${API_BASE_URL}/feedback`,
  FEEDBACK_STATS: `${API_BASE_URL}/feedback/stats`,
  
  // Performance endpoints
  PERFORMANCE_STAFF: (staffId) => `${API_BASE_URL}/performance/staff/${staffId}`,
  PERFORMANCE_RESTAURANT: (restaurantId) => `${API_BASE_URL}/performance/restaurant/${restaurantId}`,
  PERFORMANCE_LEADERBOARD: (restaurantId) => `${API_BASE_URL}/performance/leaderboard/${restaurantId}`,
  
  // Order endpoints (updated)
  ORDER_UPDATE_STATUS: (id) => `${API_BASE_URL}/orders/${id}/status`,
  ORDER_ASSIGN_WAITER: (id) => `${API_BASE_URL}/orders/${id}/assign-waiter`,
  ORDER_ASSIGN_COOK: (id) => `${API_BASE_URL}/orders/${id}/assign-cook`,
  ORDER_UPDATE_ITEM_STATUS: (id) => `${API_BASE_URL}/orders/${id}/item-status`,
  STAFF_CHECKED_IN: (restaurantId) => `${API_BASE_URL}/staff/checked-in/${restaurantId}`,
  ORDERS_KITCHEN: (restaurantId) => `${API_BASE_URL}/orders/kitchen/${restaurantId}`,
  ORDERS_WAITER: (restaurantId) => `${API_BASE_URL}/orders/waiter/${restaurantId}`,
  ORDERS_WAITER_STATS: `${API_BASE_URL}/orders/waiter-stats`,
  ORDERS_FLOW: (restaurantId) => `${API_BASE_URL}/orders/flow/${restaurantId}`,
  TABLES_WAITER_ASSIGNED: `${API_BASE_URL}/tables/waiter/assigned`,
  TABLE_ASSIGN: (id) => `${API_BASE_URL}/tables/${id}/assign`,
  TABLE_STATUS_WAITER: (id) => `${API_BASE_URL}/tables/${id}/status-waiter`,
  
  // Cook endpoints
  COOK_ORDERS: (restaurantId) => `${API_BASE_URL}/cook/orders/${restaurantId}`,
  COOK_ORDERS_AUTO_ASSIGN: (restaurantId) => `${API_BASE_URL}/cook/orders/auto-assign/${restaurantId}`,
  COOK_ORDER_ASSIGN: (orderId) => `${API_BASE_URL}/cook/orders/${orderId}/assign`,
  COOK_ORDER_UPDATE_STATUS: (orderId) => `${API_BASE_URL}/cook/orders/${orderId}/status`,
  COOK_ORDER_CALL_WAITER: (orderId) => `${API_BASE_URL}/cook/orders/${orderId}/call-waiter`,
  COOK_ORDER_ADD_NOTE: (orderId) => `${API_BASE_URL}/cook/orders/${orderId}/note`,
  COOK_STATS: `${API_BASE_URL}/cook/stats`,
  COOK_PERFORMANCE: (cookId) => `${API_BASE_URL}/cook/performance/${cookId}`,
  
  // Auth endpoints (updated)
  AUTH_RESET_PASSWORD: `${API_BASE_URL}/auth/reset-password`,
  AUTH_FORGOT_PASSWORD: `${API_BASE_URL}/auth/forgot-password`,
  AUTH_RESET_PASSWORD_TOKEN: `${API_BASE_URL}/auth/reset-password-token`,

  // Restro AI Lite — subscription tenants (super admin)
  RESTRO_LITE_STATS: `${API_BASE_URL}/restro-lite/stats`,
  RESTRO_LITE_TENANTS: (filter) =>
    `${API_BASE_URL}/restro-lite/tenants${filter && filter !== 'all' ? `?filter=${filter}` : ''}`,
  RESTRO_LITE_TENANTS_CREATE: `${API_BASE_URL}/restro-lite/tenants`,
  RESTRO_LITE_TENANT: (id) => `${API_BASE_URL}/restro-lite/tenants/${id}`,
  RESTRO_LITE_EXTEND: (id) => `${API_BASE_URL}/restro-lite/tenants/${id}/subscription`,
  RESTRO_LITE_FORCE_LOGOUT: (id) => `${API_BASE_URL}/restro-lite/tenants/${id}/force-logout`,
  RESTRO_LITE_APP_RELEASE: `${API_BASE_URL}/restro-lite/app-release`,
  RESTRO_LITE_PUSH_STATS: `${API_BASE_URL}/restro-lite/push/stats`,
  RESTRO_LITE_PUSH_BROADCAST: `${API_BASE_URL}/restro-lite/push/broadcast`,

  RESTRO_LITE_LEADS_SUBMIT: `${API_BASE_URL}/restro-lite/leads`,

  RESTRO_LITE_LEADS_LIST: (dateFilter, statusFilter) => {
    const params = new URLSearchParams();
    if (dateFilter) params.set('filter', dateFilter);
    if (statusFilter && statusFilter !== 'all') params.set('status', statusFilter);
    const q = params.toString();
    return `${API_BASE_URL}/restro-lite/leads${q ? `?${q}` : ''}`;
  },
  RESTRO_LITE_LEAD_STATUS: (id) => `${API_BASE_URL}/restro-lite/leads/${id}/status`,
  RESTRO_LITE_LEAD_DELETE: (id) => `${API_BASE_URL}/restro-lite/leads/${id}`,

  // Company employees (super admin — RestroAI internal team)
  COMPANY_EMPLOYEES: (q, active) => {
    const params = new URLSearchParams();
    if (q && String(q).trim()) params.set('q', String(q).trim());
    if (active === 'true' || active === 'false') params.set('active', active);
    const query = params.toString();
    return `${API_BASE_URL}/company-employees${query ? `?${query}` : ''}`;
  },
  COMPANY_EMPLOYEES_CREATE: `${API_BASE_URL}/company-employees`,
  COMPANY_EMPLOYEE: (id) => `${API_BASE_URL}/company-employees/${id}`,
  COMPANY_EMPLOYEE_RESEND_CREDENTIALS: (id) =>
    `${API_BASE_URL}/company-employees/${id}/resend-credentials`,
  COMPANY_EMPLOYEE_PERFORMANCE: (dateFilter, from, to) => {
    const params = new URLSearchParams();
    if (dateFilter && dateFilter !== 'all') params.set('filter', dateFilter);
    if (from) params.set('from', from);
    if (to) params.set('to', to);
    const q = params.toString();
    return `${API_BASE_URL}/company-employees/performance${q ? `?${q}` : ''}`;
  },
  COMPANY_EMPLOYEE_PORTAL_DASHBOARD: (dateFilter, from, to) => {
    const params = new URLSearchParams();
    if (dateFilter && dateFilter !== 'all') params.set('filter', dateFilter);
    if (from) params.set('from', from);
    if (to) params.set('to', to);
    const q = params.toString();
    return `${API_BASE_URL}/company-employees/portal/dashboard${q ? `?${q}` : ''}`;
  },
  COMPANY_EMPLOYEE_PORTAL_ME: `${API_BASE_URL}/company-employees/portal/me`,
};

export { API_BASE_URL };
export default API_BASE_URL;